'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function isObject(maybeObj) {
  return typeof maybeObj === 'object' && maybeObj !== null;
}

exports['default'] = isObject;
